export default "__VITE_ASSET__WhdLNoWU__"